import React from 'react';
import * as Styles from './FormInput.styles';

type Props = {
	placeholder: string;
	value: string;
	onChange: (value: string) => void;
	error: boolean;
	type?: React.HTMLInputTypeAttribute;
	errorMessage: string;
};

export const FormInput = (props: Props) => {
	return (
		<Styles.Wrapper>
			<Styles.Input
				value={props.value}
				onChange={(e) => props.onChange(e.target.value)}
				placeholder={props.placeholder}
				type={props.type || 'text'}
			/>
			{props.error && (
				<Styles.StyledX
					data-tooltip-id="rtip-1"
					data-tooltip-content={props.errorMessage}
				/>
			)}
		</Styles.Wrapper>
	);
};
